import Compiler from "vue-template-compiler"
import { Node } from "tiptap"

export default class Iframe extends Node {
  get name() {
    return "iframe"
  }

  get schema() {
    return {
      attrs: {
        src: {
          default: null
        },
        style: { default: "width:540px; height:270px" }
      },
      group: "block",
      selectable: false,
      parseDOM: [
        {
          tag: "iframe",
          getAttrs: dom => ({
            src: dom.getAttribute("src"),
            style: dom.getAttribute("style")
          })
        }
      ],
      toDOM: node => [
        "iframe",
        {
          src: node.attrs.src,
          style: node.attrs.style,
          frameborder: 0,
          allowfullscreen: true
        }
      ]
    }
  }

  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }

  get view() {
    return {
      props: ["node", "updateAttrs", "view"],
      computed: {
        src: {
          get() {
            return this.node.attrs.src
          },
          set(src) {
            this.updateAttrs({
              src
            })
          }
        },
        style: {
          get() {
            return this.node.attrs.style
          },
          set(style) {
            this.updateAttrs({
              style
            })
          }
        }
      },
      render(h) {
        return h("div", { class: "iframe" }, [
          h("center", [
            h("iframe", {
              class: "iframe__embed",
              domProps: {
                src: this.src,
                style: this.style
              }
            })
          ])
        ])
      }
    }
  }
}
